import React, { useState, useEffect } from 'react';
import { AZUL, LARANJA, CINZA, VERDE_WPP } from '../styles/colors';
import { salvarPedido, buscarPerfil, logoutUsuario } from '../firebase';

const PAGAMENTOS = ['Boleto 30 ddl', 'Boleto ou Pix à Vista'];
const PRAZOS     = ['5 dias úteis', '10 dias úteis'];

const PEDIDO_MINIMO = 2000;

const DADOS_PIX = {
  chave:      '00.000.000/0001-00',
  tipoChave:  'CNPJ',
  favorecido: 'INOVE SOLUÇÕES COMERCIAIS / APOIO',
  banco:      '000 - Banco Exemplo',
  agencia:    '0001',
  conta:      '00000-0',
  cnpj:       '00.000.000/0001-00',
};

function precoParaFloat(preco) {
  if (typeof preco === 'number') return preco;
  if (!preco || preco === 'Consultar') return 0;
  return parseFloat(String(preco).replace('R$ ', '').replace(/\./g, '').replace(',', '.')) || 0;
}

function formatarPreco(preco) {
  const valor = precoParaFloat(preco);
  if (valor === 0) return 'Consultar';
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function getImgUrl(img) {
  if (!img) return null;
  if (String(img).startsWith('http')) return img;
  return `https://www.apoio.ind.br/media/img/produtos/${img}.jpg`;
}

function Carrinho({ carrinho, onNavegar, onRemover, onAlterarQtd, perfilAtivo }) {
  const itens = carrinho || [];

  const [pagamento,   setPagamento]   = useState('');
  const [prazo,       setPrazo]       = useState('');
  const [horario,     setHorario]     = useState('');
  const [observacao,  setObservacao]  = useState('');
  const [enviando,    setEnviando]    = useState(false);
  const [vendedor,    setVendedor]    = useState(null);
  const [pedidoFeito, setPedidoFeito] = useState(false);
  const [pedidoId,    setPedidoId]    = useState(null);

  useEffect(() => {
    if (perfilAtivo?.vendedorId) {
      buscarPerfil(perfilAtivo.vendedorId)
        .then(v => setVendedor(v))
        .catch(e => console.error('Erro ao buscar vendedor:', e));
    }
  }, [perfilAtivo]);

  async function handleSair() {
    if (!window.confirm('Deseja sair da sua conta?')) return;
    try { await logoutUsuario(); } catch (e) { console.error(e); }
    localStorage.removeItem('perfil');
    window.location.reload();
  }

  const navItems = [
    { id: 'home',      emoji: '🏠', label: 'Início'   },
    { id: 'catalogo',  emoji: '📦', label: 'Catálogo' },
    { id: 'carrinho',  emoji: '🛒', label: 'Carrinho' },
    { id: 'historico', emoji: '📋', label: 'Pedidos'  },
    { id: 'perfil',    emoji: '👤', label: 'Perfil'   },
  ];

  const temApoio   = itens.some(i => i.empresa === 'apoio');
  const temEnmac   = itens.some(i => i.empresa === 'enmac');
  const fornecedor = temApoio && temEnmac
    ? 'Apoio Materiais Elétricos / Enmac Postes'
    : temEnmac ? 'Enmac Postes LTDA' : 'Apoio Materiais Elétricos';

  const subtotal = itens.reduce((acc, item) => {
    const v = precoParaFloat(item.preco);
    return acc + v * item.qtd;
  }, 0);

  const temDesconto    = pagamento === 'Boleto ou Pix à Vista';
  const valorDesconto  = temDesconto ? subtotal * 0.02 : 0;
  const total          = subtotal - valorDesconto;

  const subtotalFormatado = subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const descontoFormatado = valorDesconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const totalFormatado    = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const atingiuMinimo = subtotal >= PEDIDO_MINIMO;

  const cliente            = perfilAtivo || {};
  const clienteNome        = cliente.nome        || 'Cliente';
  const clienteRazaoSocial = cliente.razaoSocial || '';
  const clienteCnpj        = cliente.cnpj        || '';
  const clienteTelefone    = cliente.telefone    || '';
  const clienteEndereco = cliente.endereco
    ? `${cliente.endereco.rua || ''}, ${cliente.endereco.numero || ''} — ${cliente.endereco.cidade || ''}/${cliente.endereco.estado || ''}`
    : '';

  const vendedorWhatsApp = vendedor?.whatsapp
    ? '55' + vendedor.whatsapp.replace(/\D/g, '')
    : '5511999990000';

  function montarPedido() {
    return {
      clienteId:            cliente.uid        || null,
      clienteNome,
      clienteRazaoSocial,
      vendedorId:           cliente.vendedorId || null,
      vendedorNome: vendedor?.nome     || null,
      itens: itens.map(i => ({
        cod:   i.cod,
        nome:  i.nome,
        qtd:   i.qtd,
        preco: formatarPreco(i.preco),
      })),
      subtotal,
      desconto: valorDesconto,
      total,
      fornecedor,
      pagamento,
      prazo,
      horario,
      observacao,
    };
  }

  function montarMensagem(idPedido) {
    const linha = '─────────────────────';
    const numPedido = idPedido ? idPedido.slice(-8).toUpperCase() : Math.random().toString(36).substring(2, 8).toUpperCase();
    let msg = `🛒 *Pedido App-Apoio #${numPedido}*\n${linha}\n\n`;
    msg += `👤 *DADOS DO CLIENTE*\n`;
    if (clienteRazaoSocial) msg += `Razão Social: ${clienteRazaoSocial}\n`;
    msg += `CNPJ/CPF: ${clienteCnpj}\n`;
    msg += `Telefone: ${clienteTelefone}\n`;
    msg += `Endereço: ${clienteEndereco}\n\n`;
    msg += `📦 *PRODUTOS*\n${linha}\n`;
    itens.forEach(item => {
      const v   = precoParaFloat(item.preco);
      const sub = v === 0 ? 'Consultar' : (v * item.qtd).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      msg += `• ${item.nome}\n  Cód: ${item.cod} | Qtd: ${item.qtd} | ${sub}`;
      if (item.ipi && parseFloat(item.ipi) > 0) msg += ` | IPI: ${item.ipi}%`;
      msg += `\n`;
    });
    msg += `${linha}\n`;
    if (temDesconto) {
      msg += `Subtotal: ${subtotalFormatado}\n`;
      msg += `Desconto (2% pagamento antecipado): -${descontoFormatado}\n`;
    }
    msg += `💰 *Total: ${totalFormatado}*\n\n`;
    msg += `📋 *CONDIÇÕES DO PEDIDO*\n`;
    msg += `Pagamento: ${pagamento || 'Não informado'}\n`;
    if (temDesconto) msg += `(Pagamento antecipado - enviar comprovante)\n`;
    msg += `Prazo de entrega: ${prazo || 'Não informado'}\n`;
    msg += `Horário de entrega: ${horario || 'Não informado'}\n`;
    if (observacao.trim()) msg += `\n📝 *OBSERVAÇÕES*\n${observacao}\n`;
    msg += `\n_Pedido enviado pelo App Apoio Materiais Elétricos_`;
    return msg;
  }

  async function handleFinalizar() {
    if (itens.length === 0) return;
    if (!atingiuMinimo) {
      alert(`Pedido mínimo de ${PEDIDO_MINIMO.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`);
      return;
    }
    setEnviando(true);
    try {
      const id = await salvarPedido(montarPedido());
      setPedidoId(id);
      setPedidoFeito(true);
    } catch (e) {
      console.error('Erro ao salvar pedido:', e);
      alert('Erro ao finalizar pedido. Tente novamente.');
    }
    setEnviando(false);
  }

  async function handleWhatsApp(idExistente) {
    if (itens.length === 0) return;
    setEnviando(true);
    let id = idExistente;
    if (!id) {
      try { id = await salvarPedido(montarPedido()); } catch (e) { console.error(e); }
    }
    const msg = montarMensagem(id);
    window.open(`https://wa.me/${vendedorWhatsApp}?text=${encodeURIComponent(msg)}`, '_blank');
    setEnviando(false);
  }

  if (pedidoFeito) {
    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: AZUL }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px 24px', gap: 16 }}>
          <div style={{ width: 80, height: 80, borderRadius: '50%', background: '#16a34a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 40 }}>✓</div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: '#fff', marginBottom: 8 }}>Pedido realizado!</div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>Seu pedido foi enviado com sucesso e está aguardando confirmação.</div>
          </div>
          {pedidoId && (
            <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '10px 16px' }}>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', textAlign: 'center' }}>Número do pedido</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', textAlign: 'center' }}>#{pedidoId.slice(-8).toUpperCase()}</div>
            </div>
          )}
          <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: '14px 16px', width: '100%' }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginBottom: 8 }}>Resumo do pedido</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>Produtos</span>
              <span style={{ fontSize: 12, color: '#fff', fontWeight: 600 }}>{itens.length} {itens.length === 1 ? 'item' : 'itens'}</span>
            </div>
            {temDesconto && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>Desconto (2%)</span>
                <span style={{ fontSize: 12, color: '#86efac', fontWeight: 600 }}>-{descontoFormatado}</span>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>Total</span>
              <span style={{ fontSize: 14, color: '#fff', fontWeight: 700 }}>{totalFormatado}</span>
            </div>
            {pagamento && (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>Pagamento</span>
                <span style={{ fontSize: 12, color: '#fff' }}>{pagamento}</span>
              </div>
            )}
          </div>
          {temDesconto && (
            <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: 10, padding: '12px 14px', width: '100%' }}>
              <div style={{ fontSize: 11, color: '#fff', lineHeight: 1.6 }}>
                💡 Pagamento antecipado: envie o comprovante do Pix ou boleto ao seu representante pelo WhatsApp.
              </div>
            </div>
          )}
          <button onClick={() => handleWhatsApp(pedidoId)}
            style={{ width: '100%', background: VERDE_WPP, border: 'none', borderRadius: 12, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <span style={{ fontSize: 16 }}>💬</span>
            Também enviar pelo WhatsApp
          </button>
        </div>
        <div style={{ padding: '0 20px 24px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button onClick={() => onNavegar('historico')}
            style={{ width: '100%', background: '#fff', border: 'none', borderRadius: 12, padding: 14, fontSize: 14, fontWeight: 700, color: AZUL, cursor: 'pointer' }}>
            Ver Meus Pedidos →
          </button>
          <button onClick={() => onNavegar('catalogo')}
            style={{ width: '100%', background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 12, padding: 12, fontSize: 13, fontWeight: 500, color: '#fff', cursor: 'pointer' }}>
            Continuar Comprando
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: CINZA }}>

      {/* Header com navegação */}
      <div style={{ background: AZUL, padding: '14px 18px 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ color: '#fff', fontSize: 16, fontWeight: 600 }}>Carrinho</div>
            {itens.length > 0 && (
              <div style={{ background: LARANJA, borderRadius: 10, padding: '2px 8px', fontSize: 11, fontWeight: 600, color: '#fff' }}>
                {itens.length} {itens.length === 1 ? 'item' : 'itens'}
              </div>
            )}
          </div>
          <button onClick={handleSair}
            style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 11, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
            Sair
          </button>
        </div>
        {/* Navegação */}
        <div style={{ display: 'flex', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
          {navItems.map(item => (
            <div key={item.id} onClick={() => onNavegar(item.id)}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '8px 4px 10px', cursor: 'pointer', gap: 3, borderBottom: item.id === 'carrinho' ? '2px solid #fff' : '2px solid transparent' }}>
              <span style={{ fontSize: 18 }}>{item.emoji}</span>
              <span style={{ fontSize: 9, color: item.id === 'carrinho' ? '#fff' : 'rgba(255,255,255,0.6)', fontWeight: item.id === 'carrinho' ? 600 : 400 }}>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Conteúdo */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '12px 12px 0' }}>

        {itens.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 20px', gap: 12 }}>
            <span style={{ fontSize: 48 }}>🛒</span>
            <span style={{ fontSize: 14, fontWeight: 500, color: '#1a1a1a' }}>Carrinho vazio</span>
            <span style={{ fontSize: 12, color: '#aaa', textAlign: 'center' }}>Adicione produtos do catálogo para fazer seu pedido</span>
            <button onClick={() => onNavegar('catalogo')}
              style={{ marginTop: 8, background: AZUL, border: 'none', borderRadius: 10, padding: '10px 24px', fontSize: 13, fontWeight: 500, color: '#fff', cursor: 'pointer' }}>
              Ir ao Catálogo
            </button>
          </div>
        ) : (
          <>
            {vendedor && (
              <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '10px 14px', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#EAF3DE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#27500A', flexShrink: 0 }}>
                  {vendedor.nome?.split(' ').map(n => n[0]).slice(0, 2).join('')}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase' }}>Seu representante</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a' }}>{vendedor.nome}</div>
                </div>
                <div style={{ fontSize: 10, color: '#16a34a', fontWeight: 600 }}>✓ Vinculado</div>
              </div>
            )}

            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '10px 14px', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 20 }}>{temEnmac && !temApoio ? '🏗️' : '💡'}</span>
              <div>
                <div style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Fornecedor</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: AZUL }}>{fornecedor}</div>
              </div>
            </div>

            {itens.map(item => {
              const v   = precoParaFloat(item.preco);
              const sub = v === 0 ? 'Consultar' : (v * item.qtd).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
              const imgUrl = getImgUrl(item.img);
              return (
                <div key={item.cod} style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '10px 12px', marginBottom: 10, display: 'flex', gap: 10, alignItems: 'center' }}>
                  <div style={{ width: 44, height: 44, background: '#f8f8f7', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    {imgUrl ? (
                      <img src={imgUrl} alt={item.nome} style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 4 }} onError={e => { e.target.style.display = 'none'; }} />
                    ) : (
                      <span style={{ fontSize: 20 }}>{item.empresa === 'enmac' ? '🏗️' : '💡'}</span>
                    )}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 9, fontWeight: 600, color: LARANJA, textTransform: 'uppercase', marginBottom: 1 }}>{item.linha}</div>
                    <div style={{ fontSize: 11, color: '#1a1a1a', fontWeight: 500, lineHeight: 1.3, marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.nome}</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #e0e0dd', borderRadius: 7, overflow: 'hidden' }}>
                        <button onClick={() => onAlterarQtd(item.cod, item.qtd - 1)} style={{ width: 26, height: 26, border: 'none', background: '#f4f4f2', color: '#333', fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>−</button>
                        <span style={{ minWidth: 28, textAlign: 'center', fontSize: 12, fontWeight: 600, color: '#1a1a1a' }}>{item.qtd}</span>
                        <button onClick={() => onAlterarQtd(item.cod, item.qtd + 1)} style={{ width: 26, height: 26, border: 'none', background: '#f4f4f2', color: '#333', fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>+</button>
                      </div>
                      <span style={{ fontSize: 13, fontWeight: 600, color: AZUL }}>{sub}</span>
                    </div>
                  </div>
                  <button onClick={() => onRemover(item.cod)} style={{ background: 'none', border: 'none', color: '#ccc', fontSize: 18, cursor: 'pointer', padding: '0 2px', flexShrink: 0 }}>✕</button>
                </div>
              );
            })}

            {!atingiuMinimo && (
              <div style={{ background: '#fffbeb', borderRadius: 10, border: '1px solid #fde68a', padding: '12px 14px', marginBottom: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#92400e', marginBottom: 2 }}>⚠️ Pedido mínimo de R$ 2.000,00</div>
                <div style={{ fontSize: 11, color: '#78350f' }}>
                  Faltam {(PEDIDO_MINIMO - subtotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} para liberar a finalização.
                </div>
              </div>
            )}

            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 10 }}>
              {temDesconto && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <span style={{ fontSize: 12, color: '#888' }}>Subtotal</span>
                    <span style={{ fontSize: 13, color: '#888' }}>{subtotalFormatado}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <span style={{ fontSize: 12, color: '#16a34a', fontWeight: 600 }}>Desconto (2% antecipado)</span>
                    <span style={{ fontSize: 13, color: '#16a34a', fontWeight: 600 }}>-{descontoFormatado}</span>
                  </div>
                </>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: '#1a1a1a' }}>Total</span>
                <span style={{ fontSize: 18, fontWeight: 700, color: AZUL }}>{totalFormatado}</span>
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a', marginBottom: 10 }}>💳 Condição de Pagamento</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7 }}>
                {PAGAMENTOS.map(p => (
                  <div key={p} onClick={() => setPagamento(p)}
                    style={{ background: pagamento === p ? AZUL : '#f4f4f2', border: `1px solid ${pagamento === p ? AZUL : '#e0e0dd'}`, borderRadius: 20, padding: '5px 12px', fontSize: 11, fontWeight: 500, color: pagamento === p ? '#fff' : '#555', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    {p}
                  </div>
                ))}
              </div>
              {temDesconto && (
                <div style={{ marginTop: 8, fontSize: 10, color: '#16a34a', lineHeight: 1.5 }}>
                  ✓ Desconto de 2% aplicado. Pagamento antecipado — envie o comprovante do Pix ou boleto ao seu representante.
                </div>
              )}
            </div>

            {temDesconto && (
              <div style={{ background: '#fff', borderRadius: 10, border: '2px solid #16a34a', padding: '14px', marginBottom: 10 }}>
                <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '10px 12px', marginBottom: 14, textAlign: 'center' }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#dc2626' }}>⚠️ DADOS DE TESTE</div>
                  <div style={{ fontSize: 11, color: '#991b1b', marginTop: 2 }}>Não realizar pagamento. Tela em fase de testes.</div>
                </div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#16a34a', marginBottom: 4, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 16 }}>📲</span> Pagamento via Pix
                </div>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 14 }}>
                  Pague com o valor já com desconto: <strong style={{ color: '#16a34a' }}>{totalFormatado}</strong>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
                  <img src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(DADOS_PIX.chave)}`} alt="QR Code Pix"
                    style={{ width: 180, height: 180, border: '1px solid #e8e8e5', borderRadius: 8, padding: 6, background: '#fff' }}
                    onError={e => { e.target.style.display = 'none'; }} />
                </div>
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 10, color: '#aaa', textTransform: 'uppercase', marginBottom: 4 }}>Chave Pix ({DADOS_PIX.tipoChave})</div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <div style={{ flex: 1, background: '#f4f4f2', borderRadius: 8, padding: '10px 12px', fontSize: 13, fontWeight: 600, color: '#1a1a1a', wordBreak: 'break-all' }}>{DADOS_PIX.chave}</div>
                    <button onClick={() => { navigator.clipboard?.writeText(DADOS_PIX.chave); alert('Chave Pix copiada!'); }}
                      style={{ background: '#16a34a', border: 'none', borderRadius: 8, padding: '10px 14px', fontSize: 12, fontWeight: 600, color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      Copiar
                    </button>
                  </div>
                </div>
                <div style={{ background: '#f8f8f7', borderRadius: 8, padding: '12px 14px', marginBottom: 12 }}>
                  <div style={{ fontSize: 10, color: '#aaa', textTransform: 'uppercase', marginBottom: 6 }}>Dados Bancários</div>
                  <div style={{ fontSize: 12, color: '#555', lineHeight: 1.9 }}>
                    <div><span style={{ color: '#aaa' }}>Favorecido: </span><strong>{DADOS_PIX.favorecido}</strong></div>
                    <div><span style={{ color: '#aaa' }}>CNPJ: </span>{DADOS_PIX.cnpj}</div>
                    <div><span style={{ color: '#aaa' }}>Banco: </span>{DADOS_PIX.banco}</div>
                    <div><span style={{ color: '#aaa' }}>Agência: </span>{DADOS_PIX.agencia}</div>
                    <div><span style={{ color: '#aaa' }}>Conta: </span>{DADOS_PIX.conta}</div>
                  </div>
                </div>
                <div style={{ background: '#fffbeb', borderRadius: 8, padding: '10px 12px', border: '1px solid #fde68a' }}>
                  <div style={{ fontSize: 11, color: '#92400e', lineHeight: 1.6 }}>
                    ⚠️ Após o pagamento, <strong>envie o comprovante</strong> ao seu representante pelo WhatsApp para confirmarmos seu pedido.
                  </div>
                </div>
              </div>
            )}

            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a', marginBottom: 10 }}>🚚 Prazo de Entrega</div>
              <div style={{ display: 'flex', gap: 7, flexWrap: 'wrap' }}>
                {PRAZOS.map(p => (
                  <div key={p} onClick={() => setPrazo(p)}
                    style={{ background: prazo === p ? AZUL : '#f4f4f2', border: `1px solid ${prazo === p ? AZUL : '#e0e0dd'}`, borderRadius: 20, padding: '5px 12px', fontSize: 11, fontWeight: 500, color: prazo === p ? '#fff' : '#555', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    {p}
                  </div>
                ))}
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>🕐 Horário de Entrega</div>
              <input value={horario} onChange={e => setHorario(e.target.value)} placeholder="Ex: Das 8h às 12h"
                style={{ width: '100%', background: '#f8f8f7', border: '1px solid #e0e0dd', borderRadius: 8, padding: '9px 12px', fontSize: 12, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#1a1a1a' }} />
            </div>

            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>👤 Dados para NF</div>
              <div style={{ fontSize: 11, color: '#555', lineHeight: 1.8 }}>
                {clienteRazaoSocial && <div><span style={{ color: '#aaa' }}>Razão Social: </span>{clienteRazaoSocial}</div>}
                <div><span style={{ color: '#aaa' }}>CNPJ/CPF: </span>{clienteCnpj}</div>
                <div><span style={{ color: '#aaa' }}>Telefone: </span>{clienteTelefone}</div>
                <div><span style={{ color: '#aaa' }}>Endereço: </span>{clienteEndereco}</div>
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e8e8e5', padding: '12px 14px', marginBottom: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>📝 Observações</div>
              <textarea value={observacao} onChange={e => setObservacao(e.target.value)} placeholder="Ex: Entregar na portaria, solicitar NF..."
                style={{ width: '100%', background: '#f8f8f7', border: '1px solid #e0e0dd', borderRadius: 8, padding: '8px 10px', fontSize: 12, outline: 'none', resize: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#1a1a1a', minHeight: 60 }} />
            </div>
          </>
        )}
      </div>

      {/* Botões */}
      {itens.length > 0 && (
        <div style={{ padding: '10px 12px 12px', background: '#fff', borderTop: '1px solid #e8e8e5' }}>
          {vendedor && (
            <div style={{ fontSize: 11, color: '#aaa', textAlign: 'center', marginBottom: 8 }}>
              📲 Representante: {vendedor.nome}
            </div>
          )}
          <button onClick={handleFinalizar} disabled={enviando || !atingiuMinimo}
            style={{ width: '100%', background: (enviando || !atingiuMinimo) ? '#aaa' : AZUL, border: 'none', borderRadius: 12, padding: '13px', fontSize: 14, fontWeight: 600, color: '#fff', cursor: (enviando || !atingiuMinimo) ? 'not-allowed' : 'pointer', marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <span style={{ fontSize: 18 }}>✅</span>
            {enviando ? 'Finalizando...' : !atingiuMinimo ? 'Pedido mínimo R$ 2.000,00' : 'Finalizar Pedido'}
          </button>
          <button onClick={() => handleWhatsApp(null)} disabled={enviando}
            style={{ width: '100%', background: enviando ? '#aaa' : VERDE_WPP, border: 'none', borderRadius: 12, padding: '13px', fontSize: 14, fontWeight: 600, color: '#fff', cursor: enviando ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <span style={{ fontSize: 18 }}>💬</span>
            {enviando ? 'Aguarde...' : 'Enviar pelo WhatsApp'}
          </button>
        </div>
      )}

    </div>
  );
}

export default Carrinho;